import styled from "styled-components";
import { motion } from "framer-motion";

export const StyledHomePageContactWrapper = styled(motion.div)`
  padding: 90px 0 260px;

  .contact-title {
    position: relative;
    z-index: 10;

    span {
      color: #9B68E4;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 40px 0 70px;

    .contact-title {
      margin-bottom: 20px;
      font-size: 26px;
    }
  }
`;

export const StyledContactFormWrapper = styled.form`
  margin: 0 auto;
  max-width: 300px;
  width: 100%;
  position: relative;
  text-align: center;

  .contact-form__submit {
    position: relative;
    z-index: 10;
  }

  .loading-button {
    div {
      padding: 18px 55px;
      font-size: 20px;
    }
  }

  @media screen and (min-width: 768px) {
    max-width: 455px;
    .contact-form__input {
      input,
      textarea {
        padding: 14px 20px;
        font-size: 16px;
      }
    }

    .contact-form__submit {
      padding: 18px 55px;
      font-size: 20px;
    }
  }

  @media screen and (max-width: 768px) {
    .contact-form__submit {
      padding: 11px 32px;
      font-size: 20px;
    }
    .loading-button {
      div {
        padding: 11px 32px;
      }
    }
    &:before {
      top: -110px;
      left: -140px;
      background: rgba(155, 104, 228, 0.2);;
      filter: blur(20px);
    }
  }

  @media (max-width: 576px) {
    max-width: 100%;
  }
`;